<template>
  <v-card outlined class="mx-auto" color="fondoformulario">
    <v-card-text>
      <v-row dense>
        <v-col cols="6" md="1">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            dense
            v-model="afiparent"
            label="Nro.Afiliado"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <cboParentesco
            readonly
            v-model="beneficiario.id_parentesco"
          ></cboParentesco>
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            class="upperText"
            dense
            v-model="beneficiario.apellido_y_nombre"
            label="Apellido y Nombre"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="1">
          <v-combobox
            :items="['F', 'M']"
            label="Sexo"
            v-model="beneficiario.sexo"
            readonly
            filled
            outlined
            dense
            hide-details
          ></v-combobox>
        </v-col>
        <v-col cols="6" md="1">
          <cboTipo_documento
            readonly
            v-model="beneficiario.id_tipo_documento"
          ></cboTipo_documento>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            dense
            v-model="beneficiario.nro_doc"
            label="Nro.Documento"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            dense
            v-model="beneficiario.cuil"
            label="Cuil"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6" md="2">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            type="date"
            dense
            v-model="beneficiario.fecha_nacimiento"
            label="Fecha de Nacimiento"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="1">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            dense
            v-model="edad"
            label="Edad"
          ></v-text-field>
        </v-col>

        <v-col cols="6" md="2">
          <cboEstado_Civil
            readonly
            v-model="beneficiario.id_estado_civil"
          ></cboEstado_Civil>
        </v-col>
        <v-col cols="6" md="2">
          <cboNacionalidades
            readonly
            v-model="beneficiario.id_nacionalidad"
          ></cboNacionalidades>
        </v-col>

        <v-col cols="6" md="3">
          <v-text-field
            hide-details
            placeholder=" "
            outlined
            dense
            v-model="beneficiario.mail"
            label="Mail"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            hide-details
            placeholder=" "
            outlined
            dense
            v-model="beneficiario.telefono"
            label="Telefono"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            hide-details
            placeholder=" "
            outlined
            dense
            v-model="beneficiario.celular"
            label="Celular"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            dense
            v-model="beneficiario.domicilio"
            label="Domicilio"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="1">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            dense
            v-model.number="beneficiario.codigo_postal"
            label="C.Postal"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="3">
          <cboLocalidades readonly v-model="localidad"></cboLocalidades>
        </v-col>
        <v-col cols="6" md="3">
          <provSeleccionada
            :id_provincia="beneficiario.id_provincia"
            outlined
          ></provSeleccionada>
        </v-col>
        <v-col cols="6" md="2">
          <cboSeccionales
            readonly
            v-model="beneficiario.id_seccional"
          ></cboSeccionales>
        </v-col>
        <v-col cols="6" md="2">
          <cboConvenio
            readonly
            v-model="beneficiario.id_convenio_prestacional"
          ></cboConvenio>
        </v-col>
        <v-col cols="6" md="2">
          <cboPlan
            readonly
            :id_convenio="beneficiario.id_convenio_prestacional"
            v-model="beneficiario.id_plan"
          ></cboPlan>
        </v-col>
        <v-col cols="6" md="2">
          <cboSituacion_Revista
            readonly
            v-model="beneficiario.id_sit_revista"
          ></cboSituacion_Revista>
        </v-col>
        <v-col cols="6" md="2">
          <cboTipo_Afiliacion
            readonly
            v-model="beneficiario.id_tipo_afiliacion"
          ></cboTipo_Afiliacion>
        </v-col>
        <v-col cols="6" md="2"> </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            type="date"
            dense
            readonly
            v-model="beneficiario.fecha_alta"
            label="Fecha de Alta"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            hide-details
            placeholder=" "
            outlined
            dense
            readonly
            filled
            :value="fechadebaja"
            label="Fecha de Baja"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <v-text-field
            hide-details
            filled
            placeholder=" "
            outlined
            readonly
            dense
            type="date"
            v-model="beneficiario.fecha_fin_cobertura"
            label="Fecha Fin Cobertura"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="2">
          <cboMotivoBaja
            readonly
            v-model="beneficiario.id_motivo_baja"
          ></cboMotivoBaja>
        </v-col>
      </v-row>
      <v-row v-if="mostrarGuardado">
        <v-col md="1">
          <v-btn small class="green" @click="guardar()">Guardar</v-btn>
        </v-col>
        <v-col md="1">
          <v-btn small class="red" @click="cancelar()">Cancelar</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import cboTipo_Afiliacion from "@/components/Tipo_afiliacion/Combo";
import provSeleccionada from "@/components/Provincias/Seleccionada";
import cboLocalidades from "@/components/Localidades/Combo";
import cboSeccionales from "@/components/Seccionales/Combo";
import cboEstado_Civil from "@/components/Estado_Civil/Combo";
import cboParentesco from "@/components/Parentesco/Combo";
import cboSituacion_Revista from "@/components/Situacion_Revista/Combo";
import cboTipo_documento from "@/components/Tipo_documento/Combo";
import cboZonas from "@/components/Zonas/Combo";
import cboNacionalidades from "@/components/Nacionalidades/Combo";
import cboConvenio from "@/components/ConveniosPrestacionales/Combo";
import cboPlan from "@/components/Planes/Combo";
import cboMotivoBaja from "@/components/Motivos_de_baja/Combo";

import LUM from "@/lib/LUM";
import { mapActions } from "vuex";

export default {
  props: {
    beneficiario: Object,
  },
  data() {
    return {
      mailOriginal: "",
      telefonoOriginal: "",
      celularOriginal: "",
    };
  },
  components: {
    provSeleccionada,
    cboTipo_Afiliacion,
    cboLocalidades,
    cboSeccionales,
    cboEstado_Civil,
    cboParentesco,
    cboSituacion_Revista,
    cboTipo_documento,
    cboZonas,
    cboNacionalidades,
    cboConvenio,
    cboMotivoBaja,
    cboPlan,
  },
  computed: {
    afiparent() {
      return this.beneficiario.nro_afi + "/" + this.beneficiario.parent;
    },
    edad() {
      let ret = "";
      if (this.beneficiario.fecha_nacimiento) {
        let anios = LUM.edad(
          new Date(this.beneficiario.fecha_nacimiento.replace(/-/g, ","))
        );
        if (anios || anios == 0) {
          ret = anios + (anios == 1 ? " año" : " años");
        }
      }
      return ret;
    },
    localidad: {
      get: function() {
        return {
          id_localidad: this.beneficiario.id_localidad,
          codigo_postal: this.beneficiario.codigo_postal,
          id_provincia: this.beneficiario.id_provincia,
        };
      },
      set: function(newValue) {
        this.beneficiario.id_localidad = newValue.id_localidad;
        this.beneficiario.id_provincia = newValue.id_provincia;
      },
    },
    bgdiscapacitado() {
      let ret = "";
      if (this.discapacitado == "SI") {
        ret = "green lighten-3";
      }
      return ret;
    },
    fechadebaja() {
      if (this.beneficiario.fecha_baja) {
        return LUM.dataStringToDDMMYYYY(this.beneficiario.fecha_baja);
      } else {
        return "";
      }
    },
    mostrarGuardado() {
      return (
        this.mailOriginal != this.beneficiario.mail ||
        this.telefonoOriginal != this.beneficiario.telefono ||
        this.celularOriginal != this.beneficiario.celular
      );
    },
    // id_plan: {
    //   get: function() {
    //     let ret = 0;
    //     if (this.beneficiario.parent == 0) {
    //       ret = this.beneficiario.id_plan;
    //     } else {
    //       ret = this.titular.id_plan;
    //     }
    //     return ret;
    //   },
    //   set: function(value) {
    //     this.beneficiario.id_plan = value;
    //   },
    // },
    // id_convenio_prestacional: {
    //   get: function() {
    //     let ret = 0;
    //     if (this.beneficiario.parent == 0) {
    //       ret = this.beneficiario.id_convenio_prestacional;
    //     } else {
    //       ret = this.titular.id_convenio_prestacional;
    //     }
    //     return ret;
    //   },
    //   set: function(value) {
    //     this.beneficiario.id_convenio_prestacional = value;
    //   },
    // },
  },
  methods: {
    ...mapActions("beneficiarios", ["modificarBeneficiario"]),
    guardar() {
      this.modificarBeneficiario(this.beneficiario);
      this.mailOriginal = this.beneficiario.mail;
      this.telefonoOriginal = this.beneficiario.telefono;
      this.celularOriginal = this.beneficiario.celular;
    },
    cancelar() {
      this.beneficiario.mail = this.mailOriginal;
      this.beneficiario.telefono = this.telefonoOriginal;
      this.beneficiario.celular = this.celularOriginal;
    },
  },
  mounted() {
    this.mailOriginal = this.beneficiario.mail;
    this.telefonoOriginal = this.beneficiario.telefono;
    this.celularOriginal = this.beneficiario.celular;
  },
  watch: {
    beneficiario() {
      this.mailOriginal = this.beneficiario.mail;
      this.telefonoOriginal = this.beneficiario.telefono;
      this.celularOriginal = this.beneficiario.celular;
    },
  },
};
</script>

<style></style>
